import { RPC_URLS } from "@/constants/chain-rpc";
import { getChainNameFromDomainId } from "@/utils/cctp/domains";

// ---------------------------------------------------------------------------
// CCTP MessageTransmitter contract addresses — all chains, keyed by domain ID
// CCTP always operates on mainnet regardless of the Aptos DEX environment.
// ---------------------------------------------------------------------------

const MESSAGE_TRANSMITTER_CONTRACTS: Record<number, string> = {
  0: "0x0a992d191DEeC32aFe36203Ad87D7d289a738F81", // Ethereum
  3: "0xC30362313FBBA5cf9163F0bb16a0e01f01A896ca", // Arbitrum
  5: "CCTPmbSD7gX1bxKPAmg77w8oFzNFpaQiQUWD43TKaecd", // Solana (base58)
  6: "0xAD09780d193884d503182aD4588450C416D6F9D4", // Base
  9: "0x177e17751820e4b4371873ca8c30279be63bdea63b88ed0f2239c2eea10f1772", // Aptos
};

export function getMessageTransmitterContract(domainId: number): string | undefined {
  return MESSAGE_TRANSMITTER_CONTRACTS[domainId];
}

/** Resolve the RPC URL for a CCTP domain ID via the central RPC_URLS config. */
export function getRpcForDomain(domainId: number): string | undefined {
  const chainName = getChainNameFromDomainId(domainId);
  if (!chainName) return undefined;
  return RPC_URLS[chainName];
}

export const APTOS_CCTP_DOMAIN_ID = 9;
export const SOLANA_CCTP_DOMAIN_ID = 5;
export const SUI_CCTP_DOMAIN_ID = 8;

export function bytesToHex(bytes: Uint8Array): string {
  let hex = "";
  for (const b of bytes) {
    hex += b.toString(16).padStart(2, "0");
  }
  return hex;
}
